// actionTypes.js
export const SET_VALUE_TICKET = "SET_VALUE_TICKET";
export const SET_EN_COURS_TICKET = "SET_EN_COURS_TICKET";
export const SET_CORRIGER_TICKET = "SET_CORRIGER_TICKET";
export const SET_LIVRE_TICKET = "SET_LIVRE_TICKET";
export const SET_EN_ATTENTE_VALIDATION_TICKET =
  "SET_EN_ATTENTE_VALIDATION_TICKET";
export const SET_VALIDE_TICKET = "SET_VALIDE_TICKET";
export const SET_A_CORRIGER_TICKET = "SET_A_CORRIGER_TICKET";
export const SET_ANNULER_TICKET = "SET_ANNULER_TICKET";
export const SET_DATE_TICKET = "SET_DATE_TICKET";
export const SET_TYPE_TICKET = "SET_TYPE_TICKET";
export const SET_CRITICITE_TICKET = "SET_CRITICITE_TICKET";

export const SET_STATUT_LIV_TICKET = "SET_STATUT_LIV_TICKET";
export const SET_STATUT_REQ_TICKET = "SET_STATUT_REQ_TICKET";

export const SET_CURRENT_PAGE_TICKET = "SET_CURRENT_PAGE_TICKET";
export const SET_SELECTED_OPTIONS_TICKET = "SET_SELECTED_OPTIONS_TICKET";
export const SET_ORDER_TICKET = "SET_ORDER_TICKET";
export const SET_SORT_FIELD_TICKET = "SET_SORT_FIELD_TICKET";
